import type { RaceEventConfig } from './types';
import { InventoryItem } from '../../app/resources/types';
import { EventConditionType } from '../../app/state/events/types';
import { MS_IN_HOUR } from '../../utils/time-utils';

export const raceEventConfigs: RaceEventConfig[] = [
  {
    eventTitle: 'Race Event',
    joinWindowHours: 24,
    durationHours: 2,
    levelsToBeat: 5,
    conditions: [
      { type: EventConditionType.RaceEventCooldown, cooldown: MS_IN_HOUR * 18 },
      { type: EventConditionType.ReachedLevel, level: 5 },
    ],
    rewards: [
      { [InventoryItem.Coin]: 200, [InventoryItem.BoosterHammer]: 1 },
      { [InventoryItem.Coin]: 100 },
      { [InventoryItem.Coin]: 50 },
    ],
  },
];
